<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card>
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center">Dados da Análise do Leite</v-card-title>
      <v-card-text>
        <div class="col-md-12 d-flex flex-wrap justify-content-evenly">
          <p><strong>Nome:</strong> {{milkAnalysis.name}}</p>
          <p><strong>Gordura:</strong> {{milkAnalysis.fat}}</p>
          <p><strong>Proteína:</strong> {{milkAnalysis.protein}}</p>
          <p><strong>Lactose:</strong> {{milkAnalysis.lactose}}</p>
          <p><strong>CCS:</strong> {{milkAnalysis.ccs}}</p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalAnalysis",
  props:{
    active:Boolean,
    milkAnalysis:Object
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>